import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ChipModule } from 'primeng/chip'
import { InterventionEditAffairProductModel } from '../../../../core/models/intervention-edit.model'

@Component({
  selector: 'app-intervention-products',
  standalone: true,
  imports: [CommonModule, ChipModule],
  templateUrl: './intervention-products.component.html',
  styleUrls: ['./intervention-products.component.scss'],
})
export class InterventionProductsComponent {
  @Input() products: InterventionEditAffairProductModel[] = []

  /**
   * Calcule le total des produits
   */
  get totalPrice(): number {
    if (!this.products?.length) return 0

    return this.products.reduce((total, product) => {
      return total + product.price * product.quantity
    }, 0)
  }
}
